import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiUsuariosService} from '../../../services/administracion/vmi-usuarios.service';
import {VmiRolesService} from '../../../services/administracion/vmi-roles.service';
import {RolModel} from '../../../services/administracion/vmi-rolModel';
import {UsuarioModel} from '../../../models/vmi-usuarioModel';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {LfsaBotonsGridComponent} from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import {VmiClienteUsuarioService} from '../../../services/administracion/vmi-cliente-usuario.service';
import {ClienteModel} from '../../../models/vmi-clienteModel';
import {ClienteUsuarioModel} from '../../../models/vmi-clienteUsuarioModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-usuarios',
  templateUrl: './vmi-frm-mantenedor-usuarios.component.html',
  styleUrls: ['./vmi-frm-mantenedor-usuarios.component.css']
})
export class VmiFrmMantenedorUsuariosComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  columnDefsClientes: any[];
  rowDataClientes: any[] = [];
  frameworkComponentsClientes: any;
  gridApiClientes: any;
  gridColumnApiClientes: any;
  rowSelectionClientes: any;
  loadingClientes: boolean = false;
  listaVaciaClientes: boolean = true;

  columnDefsCliUsuario: any[];
  rowDataCliUsuario: any[] = [];
  frameworkComponentsCliUsuario: any;
  gridApiCliUsuario: any;
  gridColumnApiCliUsuario: any;
  rowSelectionCliUsuario: any;
  loadingCliUsuario: boolean = false;
  listaVaciaCliUsuario: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};
  cmbRoles: RolModel[] = [];
  cmbTipoUsuario: any[] = [
    {clave: 1, valor: 'FABRIL'},
    {clave: 2, valor: 'CLIENTE'}
  ];

  idUsuario: number;
  usuarioSelected: UsuarioModel;

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _usuarios: VmiUsuariosService,
    private _rol: VmiRolesService,
    private _cliente: VmiClientesService,
    private _clientesUsuario: VmiClienteUsuarioService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.usuarios;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      usuId: [''],
      usuNombre: ['', [Validators.required]],
      usuEmail: ['', [Validators.required]],
      usuNick: ['', [Validators.required]],
      usuClave: ['', [Validators.required]],

      usuRepdDiario: ['', [Validators.required]],
      usuGestVta: ['', [Validators.required]],
      usuStockmin: ['', [Validators.required]],
      usuFincotrato: ['', [Validators.required]],

      usuEstado: [''],

      usuTipo: ['', [Validators.required]],
      rol: ['', [Validators.required]]
    });

    // setTimeout(() => {
    // debugger

    // }, 1000);

    this.gridComponent();
    this.getAll();
    this.getAllRoles();
    this.getAllClientes();
  }

  //*SERVICIOS
  getAll() {
    this._usuarios.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  getAllRoles() {
    this._rol.getAll().subscribe((res: RolModel[]) => {
      this.cmbRoles = res;
    }, (err) => {
      this.cmbRoles = [];
    });
  }

  getAllClientes() {
    this._cliente.getAll().subscribe((res: any[]) => {
      this.loadingClientes = false;
      this.rowDataClientes = res;
      this.listaVaciaClientes = (this.rowDataClientes.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loadingClientes = false;
      this.rowDataClientes = [];
      this.listaVaciaClientes = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'NOMBRE',
        field: 'usuNombre',
        sortable: true,
        filter: true,
        width: 230
      },
      {
        headerName: 'EMAIL',
        field: 'usuEmail',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'GESTION VENTA',
        field: 'usuGestVta',
        sortable: true,
        filter: true,
        width: 160,
        valueGetter: this.getCatalogo.bind(this, 'usuGestVta')
      },
      {
        headerName: 'REPORTE DIARIO',
        field: 'usuRepdDiario',
        sortable: true,
        filter: true,
        width: 160,
        valueGetter: this.getCatalogo.bind(this, 'usuRepdDiario')
      },
      {
        headerName: 'NICK',
        field: 'usuNick',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'FIN DE CONTRATO',
        field: 'usuFincotrato',
        sortable: true,
        filter: true,
        width: 150,
        valueGetter: this.getCatalogo.bind(this, 'usuFincotrato')
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.callModalAsignarClientes.bind(this),
          label: 'Clientes',//,this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';

    this.columnDefsClientes = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          labelBtn: '',
          classBtn: this.modulo.button.buttonsCss.info,
          iconBtn: 'fa fa-plus',
          tooltipMensaje: 'Agregar Cliente',
          onClick: this.saveClienteUsuario.bind(this),
        }
      },
      {
        headerName: 'RUC',
        field: 'cliRuc',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NOMBRE',
        field: 'cliNombre',
        sortable: true,
        filter: true,
        width: 300
      }
    ];
    this.frameworkComponentsClientes = {
      buttonRenderer: LfsaBotonsGridComponent,
    };
    this.rowSelectionClientes = 'multiple';

    this.columnDefsCliUsuario = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          labelBtn: '',
          classBtn: this.modulo.button.buttonsCss.danger,
          iconBtn: 'fa fa-trash',
          tooltipMensaje: '',
          onClick: this.eliminarClienteUsuario.bind(this),
        }
      },
      {
        headerName: 'RUC',
        field: 'cliRuc',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NOMBRE',
        field: 'cliNombre',
        sortable: true,
        filter: true,
        width: 300
      }
    ];
    this.frameworkComponentsCliUsuario = {
      buttonRenderer: LfsaBotonsGridComponent,
    };
    this.rowSelectionCliUsuario = 'multiple';
  }

  callModalAsignarClientes({rowData}) {
    this.usuarioSelected = rowData;
    this.idUsuario = this.usuarioSelected.usuId;
    this.getClinetesByUsuario();
    document.getElementById('abrirModal').click();
  }

  getCatalogo(tag: string, data: any) {
    return data.data[tag] === 1 ? 'SI' : 'NO';
  }


  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridReadyCliente(params) {
    this.gridApiClientes = params.api;
    this.gridColumnApiClientes = params.columnApi;
  }

  onGridReadyCliUsuario(params) {
    this.gridApiCliUsuario = params.api;
    this.gridColumnApiCliUsuario = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.formulario.get('usuRepdDiario').setValue(false);
    this.formulario.get('usuGestVta').setValue(false);
    this.formulario.get('usuStockmin').setValue(false);
    this.formulario.get('usuFincotrato').setValue(false);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const usuario: UsuarioModel = rowData;
    const obj = {
      usuId: usuario.usuId,
      usuNombre: usuario.usuNombre,
      usuEmail: usuario.usuEmail,
      usuNick: usuario.usuNick,
      usuClave: usuario.usuClave,
      usuRepdDiario: (usuario.usuRepdDiario === 1) ? true : false,
      usuGestVta: (usuario.usuGestVta === 1) ? true : false,
      usuStockmin: (usuario.usuStockmin === 1) ? true : false,
      usuFincotrato: (usuario.usuFincotrato === 1) ? true : false,
      usuEstado: usuario.usuEstado,
      usuTipo: usuario.usuTipo,
      rol: usuario.rol.rolId
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const usuario: UsuarioModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._usuarios.delete(usuario.usuId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const idRol = this.formulario.get('rol').value;
    const usuario: UsuarioModel = Object.assign(this.formulario.value);
    usuario.usuEstado = 1;
    usuario.usuRepdDiario = usuario.usuRepdDiario ? 1 : 0;
    usuario.usuGestVta = usuario.usuGestVta ? 1 : 0;
    usuario.usuStockmin = usuario.usuStockmin ? 1 : 0;
    usuario.usuFincotrato = usuario.usuFincotrato ? 1 : 0;
    usuario.rol = this.cmbRoles.find(rol => rol.rolId === idRol);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._usuarios.create(usuario),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const idRol = this.formulario.get('rol').value;
    const usuario: UsuarioModel = Object.assign(this.formulario.value);
    usuario.usuEstado = 1;
    usuario.usuRepdDiario = usuario.usuRepdDiario ? 1 : 0;
    usuario.usuGestVta = usuario.usuGestVta ? 1 : 0;
    usuario.usuStockmin = usuario.usuStockmin ? 1 : 0;
    usuario.usuFincotrato = usuario.usuFincotrato ? 1 : 0;
    usuario.rol = this.cmbRoles.find(rol => rol.rolId === idRol);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._usuarios.edit(usuario),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

  getClinetesByUsuario() {
    this.loadingCliUsuario = true;
    this._clientesUsuario.getClientesByUsuario(this.idUsuario).subscribe((res: any[]) => {
      this.loadingCliUsuario = false;
      this.rowDataCliUsuario = res.map(e => {
        let a = e.cliente;
        a.cliUsuId = e.cliUsuId;
        return a;
      });
      // console.log(this.rowDataCliUsuario);
      this.listaVaciaCliUsuario = this.rowDataCliUsuario.length === 0 ? true : false;
    }, (err) => {
      this.loadingCliUsuario = false;
      this.listaVaciaCliUsuario = true;
      this.rowDataCliUsuario = [];
    });
  }

  saveClienteUsuario({rowData}) {
    const cliente: ClienteModel = rowData;
    const clienteUsuario: ClienteUsuarioModel = {
      cliUsuId: null,
      usuarioAlerta: this.usuarioSelected,
      cliente: cliente,
    }
    let listclienteUsuario = [];
    listclienteUsuario.push(clienteUsuario);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._clientesUsuario.saveClienteUsuario(listclienteUsuario),
    }).then((res: any) => {
      this.getClinetesByUsuario();
    }).catch((err) => {
      console.log(err);
    });
  }

  saveAllClienteUsuario() {
    let listclienteUsuario = [];
    this.rowDataClientes.forEach(e => {
      const clienteUsuario: ClienteUsuarioModel = {
        cliUsuId: null,
        usuarioAlerta: this.usuarioSelected,
        cliente: e,
      }
      listclienteUsuario.push(clienteUsuario);
    });
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._clientesUsuario.saveClienteUsuario(listclienteUsuario),
    }).then((res: any) => {
      this.getClinetesByUsuario();
    }).catch((err) => {
      console.log(err);
    });
  }

  eliminarClienteUsuario({rowData}) {
    // console.log(rowData);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._clientesUsuario.deleteClienteUsuario(rowData.cliUsuId),
    }).then((res: any) => {
      this.getClinetesByUsuario();
    }).catch((err) => {
      console.log(err);
    });
  }

  eliminarAllClienteUsuario() {
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._clientesUsuario.deleteAllClienteUsuario(this.usuarioSelected.usuId),
    }).then((res: any) => {
      this.getClinetesByUsuario();
    }).catch((err) => {
      console.log(err);
    });
  }

}
